import { combineReducers } from 'redux';
import AuthReducer, { authReducer } from './AuthReducer';
import ConfigReducer from './ConfigReducer';
import CreateOrdersReducer from './CreateOrdersReducer';
import EditOrderReducer from './EditOrderReducer';
import { bookingReducer } from './CreateBookingReducer';

const rootReducer = combineReducers({
  auth: authReducer,
  config: ConfigReducer,
  createOrders: CreateOrdersReducer,
  editOrder: EditOrderReducer,
  createBookings: bookingReducer,
});

export default rootReducer;
